import React, { useState, useRef, useMemo, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";

import "ag-grid-enterprise";
import StatusBarPagination from "./StatusBarPagination";
import { Link, NavLink } from "react-router-dom/cjs/react-router-dom.min";
import { getCookie,getDisplayValue, maskEmail } from "./crm/customer/Utility";
import { decrypt, decryptconfigdata } from "../actions/common";
import cleanNestedObject from "../utils/cleanObject";
import CtaOptions from "./crm/customer/CtaOptions";
import { apiRequest } from "../utils/utils";

const AgGridComponent = ({
  agData = {},
  accountManager = null,
  salesManager = null,
  tseowner = null,
  storePermission = null,
  ctaModal,
  getAgGridData,
  ...rest
}) => {
  
  const [columnsDef, setColumnsDef] = useState([]);
  const [tooltipData, setTooltipData] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const tooltipRef = useRef(null);
  const gridRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const timeoutRef = useRef(null);
  const initialRender = useRef(true);

  

  let user_uuid = getCookie("muvi_useruuid");

  var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
  var localdata = has_local_data
    ? decrypt(localStorage.getItem("encdata"), 0)
    : "";

  const handleIconClick = (event, rowData) => {
    const { pageX, pageY } = event;

    const sidebar = document.querySelector(".left_col");

    

    setTooltipPosition({
      top: pageY - 90,
      left: pageX - sidebar.offsetWidth - 270,
    });
    setTooltipData(rowData);
  };

  const handleClickOutside = (event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      setTooltipData(null);
    }
  };

  useEffect(() => {
    const { syncFilterWithAggrid, search } = agData;
  
    if (syncFilterWithAggrid || search) {
      if (gridRef.current && gridRef.current.api) { // Removed ?. for better compatibility
        const updatedData = { ...syncFilterWithAggrid };
        let searchValue = search;
  
          gridRef.current.api.setServerSideDatasource(
            createServerSideDatasource(updatedData, searchValue)
          );
        }
        getFocusTotheColumn()
            }
    }, [agData.syncFilterWithAggrid, agData.search]);

    

  const onSortRequested = (params) => {
    
    const { colId } = params.column;
    if (params.column.sort == "undefined") {
      params.setSort("asc");
    } else if (params.column.sort === "desc") {
      params.setSort("asc");
    } else {
      params.setSort("desc");
    }
  };

  const createServerSideDatasource = (filters = null, search = null) => ({
    getRows: async (params) => {
      
      const { app_token } = agData;

      // Extract sorting information
      let sortColumn = agData.sort;
      let sortOrder = agData.order;

      if (params.request.sortModel.length > 0) {
        const { colId, sort } = params.request.sortModel[0]; // First sorted column
        sortColumn = colId;
        sortOrder = sort;
      }

      let requestdata = {
        app_token: app_token,
        attribute_set_key: agData.attribute_set_key
          ? agData.attribute_set_key
          : "crm",
        user_uuid: user_uuid ? user_uuid : localdata.user_uuid,
        filter: filters,
        current_page: gridRef.current.api.paginationProxy.currentPage + 1,
        sort: sortColumn, // Corrected sorting column
        order: sortOrder, // Corrected sorting order
        search: search,
        per_page:
          (gridRef.current &&
            gridRef.current.api &&
            gridRef.current.api.paginationProxy.pageSize) ||
          20,
        debug: true,
      };

      if (search) {
        requestdata = {
          ...requestdata,
          search: search,
        };
      }

      const callingapi = async () => {
        gridRef.current.api.showLoadingOverlay();
        const resdata = await apiRequest(
          agData.rowsApi,
          "POST",
          cleanNestedObject(requestdata),
          null,
          true
        );
        

        if (resdata.code === 200) {
          const { data: rdata, total_count } = resdata;

          if (!rdata.length) {
            gridRef.current.api.showNoRowsOverlay();
          } else {
            gridRef.current.api.hideOverlay();
          }
          rest.getTotalCount(total_count);
          params.successCallback(rdata, total_count);
        }
      };

      callingapi();
    },
  });

  const handleProcessCellForClipboard = (params) => {
    const { colDef } = params.column;
    const field = colDef.field
    if(['account_manager','sales_manager','tse_owner'].includes(field)) {
      
      const mapping = field == "account_manager" ? accountManager : field =='sales_manager' ? salesManager :tseowner;
      const value = getDisplayValue(colDef, params.node.data, (mapping || []));
      return value
    }
    const value = getDisplayValue(colDef, params.node.data);
    return value;
  };

  const onColumnMoved = (ev) => {
    if (ev.source === "uiColumnDragged") {
      const {
        columnApi: {
          columnModel: { displayedTreeCentre },
        },
      } = ev;

      const newrr = [];

      const orderinsequence = {
        app_token: process.env.REACT_APP_tattle_token,
        user_uuid: user_uuid ? user_uuid : localdata.user_uuid,
        attribute_set_key: agData.attribute_set_key
          ? agData.attribute_set_key
          : "crm",
        attributes: newrr,
      };

      displayedTreeCentre.forEach((item, i) => {
        if (item.colDef.field !== undefined) {
          newrr.push(item.colDef.field);
        }
      });

      // Clear the previous timeout if it exists
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(async () => {
        try {
          await fetch(`${process.env.REACT_APP_tattle_api}/sequence`, {
            method: "POST",
            body: JSON.stringify(orderinsequence),
          });
        } catch (err) {
          console.log(err.message);
        }
      }, 200);
    }
  };

  const onColumnResized = (params) => {
    if (params.source === "uiColumnDragged") {
      const columnspropetise = params.column.colDef;
      const formvalues = {
        ...columnspropetise,
        width: params.column.actualWidth || 275,
      };
      const { options, ...newoptions } = formvalues;
      const boardDetails = {
        app_token: process.env.REACT_APP_tattle_token,
        user_uuid: user_uuid ? user_uuid : localdata.user_uuid,
        attribute_set_key: agData.attribute_set_key
          ? agData.attribute_set_key
          : "crm",
        attributes: [formvalues.field],
        width: newoptions.width,
      };

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(async () => {
        try {
          await fetch(`${process.env.REACT_APP_tattle_api}/attribute/resize`, {
            method: "POST",
            body: JSON.stringify(boardDetails),
          });
        } catch (err) {
          console.log(err.message);
        }
      }, 200);
    } else {
      return;
    }
  };
  // check the updated props

  const callfunctionapi = async () => {
    const { columnsApi, app_token } = agData;
    let requestdata = {
      app_token,
      attribute_set_key: agData.attribute_set_key,
      user_uuid: user_uuid ? user_uuid : localdata.user_key,
    };
    const rdata = await apiRequest(columnsApi, "POST", requestdata);
    

    if (rdata.code === 200) {
      const { columns } = rdata.data;
      setColumnsDef(columns || []);
    }
  };

  useEffect(() => {
    (async () => {
      callfunctionapi();
    })();
  }, []);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }
    if (agData.loadColumns) {
      callfunctionapi();
      getFocusTotheColumn()
    }
  }, [agData.loadColumns]);

  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.setServerSideDatasource(
        createServerSideDatasource(agData.syncFilterWithAggrid)
      );
      getFocusTotheColumn()
    }
  }, [agData.recallcrmapi]);

  // useEffect(() => {
  //   if (gridRef.current && gridRef.current.api) {
  //     gridRef.current.api.setServerSideDatasource(
  //       createServerSideDatasource(agData.syncFilterWithAggrid)
  //     );
  //   }
  // }, [agData]);

  const onGridReady = (params) => {
    gridRef.current = params;
    params.api.setServerSideDatasource(
      createServerSideDatasource(agData.syncFilterWithAggrid)
    );
  };

  const getFocusTotheColumn = (index) => {
    if (!gridRef.current || !gridRef.current.api) {
      
      return;
    }
  
    setTimeout(() => {
      const allColumns = gridRef.current.columnApi.getAllDisplayedColumns();
      const firstCol = allColumns.find((col) => col.getColId() !== "actions" && col.isVisible());
  
      if (firstCol) {
        gridRef.current.api.ensureIndexVisible(index || 0);
        gridRef.current.api.setFocusedCell(index || 0, firstCol.getColId());
        
      } else {
        
      }
    }, 200); // Short delay to ensure AG Grid is rendered properly
  };

  const keepFocusHandler = (params) => {
    getFocusTotheColumn(params.rowIndex);
  }

  useEffect(() => {
    getFocusTotheColumn();
  }, [gridRef.current]);

  const hiddenColumns = async (params) => {
    
    const { colId } = params.column;
    const data = {
      app_token: agData.app_token,
      attribute_set_key: agData.attribute_set_key,
      user_uuid: user_uuid ? user_uuid : localdata.user_uuid,
      status_type: "hide",
      attributes: [colId],
    };
    const responseData = await apiRequest(
      `${process.env.REACT_APP_tattle_api}/attribute/hide`,
      "POST",
      data
    );

    if (responseData.code === 200) {
      callfunctionapi();
    }
  };

  const customerHeaderCall = (params) => {
    
    let sort;

    if (params.enableSorting) {
      sort = (
        <div className="arrow-chevron">
          <div
            className="sorting-custom"
            onClick={() => onSortRequested(params)}
          >
            <div>
              <span
                className={`customSortDownLabel sorttt ${
                  params.column.sort === "asc" ? "notdisaplay" : ""
                } desc${params.column.sort === "desc" ? "descactive" : ""}`}
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 11.0833V2.91663"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M2.9165 6.99996L6.99984 2.91663L11.0832 6.99996"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span
                className={`customSortUpLabel sorttt asc${
                  params.column.sort === "asc" ? "ascactive" : ""
                }`}
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 2.91671L7 11.0834"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.0835 7.00004L7.00016 11.0834L2.91683 7.00004"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="column_header_custom">
        <span className="hidden_columns" onClick={() => hiddenColumns(params)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
            width={15}
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
            />
          </svg>
        </span>
        <span className="ag-header-cell-text">{params.displayName}</span> {sort}
      </div>
    );
  };

  useEffect(() => {
    if (tooltipData) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => document.removeEventListener("click", handleClickOutside);
  }, [tooltipData]);

  let newcolumns = columnsDef.map((it) => {
    try {
      let newitem = {
        ...it,
        resizable: true,
        editable: false,
        headerComponent: (params) => customerHeaderCall(params),
      };
  
      if (it.field === "company_name") {
        newitem = {
          ...newitem,
          cellRenderer: (params) => {
            const { colDef } = params.column;
            const value = getDisplayValue(colDef, params.node.data);
            
            let detailsUrl;
            if (rest.isLive) {
              if (params.data.product_key == "49F37046FCD84520895FC18A4F5BFC8B") {
                detailsUrl = `/customer/prod/${params.data["customer_id"]}`;
              } else {
                detailsUrl = `/customer/prodc/${params.data["customer_id"]}`;
              }
            } else {
              detailsUrl = `/account/${params.data["customer_id"]}`;
            }

            let companyName = params.value ? params.value : params.data.name;
            if (!companyName) {
              const email = (params.data ? params.data.email : "") || "";
              companyName = email.substring(0, email.indexOf("@"));
              if (!companyName) {
                companyName = "Unknown";
              }
            }

            const logo = `https://ui-avatars.com/api/?name=${companyName}&color=ff0000&size=40&background=random`;

            return (
              <div style={{ alignItems: "center" }}>
                <img
                  src={`${logo}`}
                  className="user-image rounded"
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    marginRight: "5px",
                    objectFit: "contain",
                  }}
                  alt="logo"
                />{" "}
                <NavLink
                  to={{
                    pathname: detailsUrl,
                  }}
                >
                  {value}
                </NavLink>
              </div>
            );
          },
        };
      } else if (it.attribute_type === "api") {
        newitem = {
          ...newitem,
          cellRenderer: (params) => {
            const { options } = params.colDef;
            const value = getDisplayValue(params.colDef, params.node.data);
       
            return value || '-NA-'
          },
        };
      } else if (it.attribute_type === "date") {
        
        newitem = {
          ...newitem,
          sortable: true,
          cellRenderer: (params) => {
            const { colDef, data } = params;
            const value = getDisplayValue(colDef, params.node.data);
            
            return value
          },
        };
      } else if (
        ["account_manager", "sales_manager", "tse_owner"].includes(it.field)
      ) {
        newitem = {
          ...newitem,
          cellRenderer: (params) => {
            const { colDef, data } = params;
            const field = colDef.field;
            const mapping =  field === "account_manager"
            ? accountManager || []
            : field === "sales_manager"
            ? salesManager || []
            : tseowner || [];
            const value = getDisplayValue(colDef, params.node.data, mapping);
            
   return value;
          },
        };
      } else {
        newitem = {
          ...newitem,
          cellRenderer: (params) => {
            const { colDef, data } = params;
            const value = getDisplayValue(colDef, params.node.data);
            
            if (params.colDef.field === "domain") {
              return params.data[params.colDef.field] !== "NA" ? (
                <a href={"//" + params.data[params.colDef.field]} target="_blank">
                  {params.data[params.colDef.field]}
                </a>
              ) : (
                params.data[params.colDef.field]
              );
            }
            return <div>{value || "-NA-"}</div>;
          },
        };
      }
  
      return newitem;
    } catch (err) {
      console.log(err);
    }
  });

  // Add the pinned "Actions" column
  if (rest.action) {
    newcolumns.push({
      headerName: "",
      field: "actions",
      pinned: "right",
      suppressMovable: true,
      width: 10,
      cellRenderer: (params) => {
        const {data} = params;
        return data && data.customer_type !== "deleted" && <div
          style={{
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
            alignItems: "center",
            height: "100%",
          }}
          onClick={(e) => handleIconClick(e, params)}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.99992 8.66668C8.36811 8.66668 8.66659 8.3682 8.66659 8.00001C8.66659 7.63182 8.36811 7.33334 7.99992 7.33334C7.63173 7.33334 7.33325 7.63182 7.33325 8.00001C7.33325 8.3682 7.63173 8.66668 7.99992 8.66668Z"
              fill="#373945"
              stroke="#373945"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M7.99992 3.99999C8.36811 3.99999 8.66659 3.70151 8.66659 3.33332C8.66659 2.96513 8.36811 2.66666 7.99992 2.66666C7.63173 2.66666 7.33325 2.96513 7.33325 3.33332C7.33325 3.70151 7.63173 3.99999 7.99992 3.99999Z"
              fill="#373945"
              stroke="#373945"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M7.99992 13.3333C8.36811 13.3333 8.66659 13.0349 8.66659 12.6667C8.66659 12.2985 8.36811 12 7.99992 12C7.63173 12 7.33325 12.2985 7.33325 12.6667C7.33325 13.0349 7.63173 13.3333 7.99992 13.3333Z"
              fill="#373945"
              stroke="#373945"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </svg>
        </div>
      },
    });
  }
  return (
    <React.Fragment>
      <div
        className="ag-theme-alpine"
        style={{ height: 950, width: "100%", padding: "0 6px" }}
      >
        <AgGridReact
          ref={gridRef}
          columnDefs={newcolumns}
          rowModelType="serverSide"
          paginationPageSize={20}
          suppressHorizontalScroll={true}
          key={1}
          suppressContextMenu={true}
          onColumnResized={onColumnResized}
          blockLoadDebounceMillis={100}
          pagination={true}
          suppressMovableColumns={false}
          onColumnMoved={onColumnMoved}
          cacheBlockSize={20}
          enableServerSideFilter={true}
          enableClipboard={true}
          copyHeadersToClipboard={true}
          maxBlocksInCache={20}
          suppressPaginationPanel={true}
          processCellForClipboard={handleProcessCellForClipboard}
          onGridReady={onGridReady}
          statusBar={{
            statusPanels: [
              {
                statusPanel: StatusBarPagination,
                align: "right",
                key: "StatusBarPagination",
              },
            ],
          }}
          serverSideStoreType="partial"
          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center">Loading...</span>'
          }
          overlayNoRowsTemplate={
            '<span className="ag-overlay-loading-center">No data found.</span>'
          }
          enableRangeSelection={true}
        />
      </div>

      {/* Tooltip Modal */}
      {rest.action && tooltipData && (
        <div
          ref={tooltipRef}
          style={{
            position: "absolute",
            top: tooltipPosition.top,
            left: tooltipPosition.left,
            background: "#fff",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            borderRadius: "5px",
            zIndex: 1000,
            border: "1px solid #ddd",
            width: "254px",
          }}
          className="popup-agtheme"
        >
          <CtaOptions
            params={tooltipData}
            storePermission={storePermission}
            handleClickConfirmModal={rest.handleClickConfirmModal}
            handleClickManageMuviOwnershipModal={
              rest.handleClickManageMuviOwnershipModal
            }
            handleConfirmToManageDemoAccount={
              rest.handleConfirmToManageDemoAccount
            }
            handleClickExtendFreeTrialModal={
              rest.handleClickExtendFreeTrialModal
            }
            handleConfirmManageDemoMuvi5={rest.handleConfirmManageDemoMuvi5}
            handleClickDeleteModal={rest.handleClickDeleteModal}
            handleClickSubscriptionModal={rest.handleClickSubscriptionModal}
            extendFreeTrialHandler={rest.extendFreeTrialHandler}
            handleClickConfirmModalMuviClassic={
              rest.handleClickConfirmModalMuviClassic
            }
            handleClickRestoreModal={rest.handleClickRestoreModal}
            handleClickCancelAccountModal={rest.handleClickCancelAccountModal}
            handleClickChangePasswordModal={rest.handleClickChangePasswordModal}
            handleClickExtendTrialPeriodModal={rest.handleClickExtendTrialPeriodModal}
            manageMuviOwnerShipHandler={rest.manageMuviOwnerShipHandler}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default React.memo(AgGridComponent);



// WEBPACK FOOTER //
// ./src/components/AgGridComponent.js